import { Link } from 'react-router-dom';
import { ArrowRight, Award } from 'lucide-react';

export const AboutSection = () => {
  return (
    <section data-testid="about-section" className="py-24 bg-[#121212]">
      <div className="w-full px-4 sm:px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="aspect-[4/3] relative overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_nominate-now/artifacts/94mgoek7_about-image.jpg"
                alt="Golden Tree Events"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 border border-[#D4AF37]/30 hidden lg:block" />
            
            {/* Badge */}
            <div className="absolute -bottom-4 -left-4 bg-[#D4AF37] p-6 hidden lg:flex flex-col items-center justify-center">
              <Award className="w-8 h-8 text-black mb-2" />
              <span className="text-black font-bold text-2xl">6+</span>
              <span className="text-black/80 text-xs uppercase tracking-wider">Regions</span>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <p className="font-google-sans text-[#D4AF37] text-xs tracking-[0.3em] uppercase mb-4">About Golden Tree Events</p>
            <h2 className="font-montserrat text-3xl sm:text-4xl lg:text-5xl text-white mb-6">
              Welcome to{' '}
              <span className="gradient-gold">Golden Tree Events</span>
            </h2>
            <p className="font-google-sans text-[#A1A1AA] text-base leading-relaxed mb-4 text-justify">
              The largest award management company in the world. Honoring excellence in 20+ industries 
              from startups to Fortune 500 companies across 100+ countries.
            </p>
            <p className="font-google-sans text-[#A1A1AA] text-base leading-relaxed mb-4 text-justify">
              Golden Tree Events specializes in organizing award programs, conferences, 
              and exhibitions that create lasting impressions. We bring together industry leaders, 
              innovators, and visionaries to celebrate excellence and foster meaningful connections.
            </p>
            <p className="font-google-sans text-[#A1A1AA] text-base leading-relaxed mb-4 text-justify">
              With a presence in 6+ regions worldwide, we have successfully delivered 500+ events, 
              recognized 2000+ winners, and partnered with 20,000+ global brands. Our team of experienced 
              professionals ensures every event is executed with precision, creativity, and world-class standards.
            </p>
            <p className="font-google-sans text-[#A1A1AA] text-base leading-relaxed mb-4 text-justify">
              Our comprehensive services include event planning, venue sourcing, catering, audio-visual setup, 
              photography, VIP management, and end-to-end event execution. We handle every detail so you can 
              focus on what matters most – celebrating success and building valuable connections.
            </p>
            <p className="font-google-sans text-[#A1A1AA] text-base leading-relaxed mb-8 text-justify">
              Whether you're looking to host an awards ceremony, corporate conference, product launch, 
              or industry summit, Golden Tree Events delivers exceptional experiences that leave lasting impressions 
              on your guests and elevate your brand presence globally.
            </p>

            <Link
              to="/about"
              data-testid="about-read-more"
              className="inline-flex items-center gap-2 text-[#D4AF37] font-medium uppercase tracking-wider hover:gap-3 transition-all duration-300"
            >
              Read More About Us
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
